import React, {Component} from 'react'
import {connect} from 'react-redux'
import AddUnitButton from './addstockunit'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import {addingStock, addingStockSuccess, addingStockFailure,resetAddingStock, addDefaultStockUnits} from '../../redux/actions/stockactions'
import {getToken} from '../../storage'
import Select from 'react-select';
import DatePicker from 'react-16-bootstrap-date-picker'


class AddStockItem extends Component {

  constructor(props) {
    super(props)
    document.title = "Create New Stock Item"
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleUnitChange = this.handleUnitChange.bind(this)
    this.handleDateChange= this.handleDateChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)

    this.fetchUnits = this.fetchUnits.bind(this)
    this.state={}
    this.fetchUnits()
  }


  fetchUnits() {
    axios({
      url: '/list_stock_units/',
      method: 'get',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    }).then((response)=> {
      if(response.status === 200) {
          this.props.dispatch(addDefaultStockUnits(response.data.stock_units))
      }

    }).catch((err)=> {
      console.log(err);
    })
  }


  handleSubmit(event) {
    event.preventDefault()
    console.log("event",  event.target.name);
    if(event.target.name === "createUnitForm" || event.target.name === "createUnitNormalForm") {
      return false
    }

    console.log("Dispathcing adding stock");
    this.props.dispatch(addingStock())
    axios({
      url: '/create_new_stock/',
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state
    }).then((response)=> {
      if(response.status === 200) {
        this.props.dispatch(addingStockSuccess(response.data.stock_item))
      }
      this.props.dispatch(resetAddingStock())
      window.location = "/stock_items/"
    }).catch((err)=> {

      this.props.dispatch(addingStockFailure(err.response.data))
    })
  }

  handleDateChange(value, fValue) {
    this.setState({available_from: fValue, available_from_date: value})
  }

  handleUnitChange(option) {
    this.setState({unit:option.value})
  }
  handleInputChange(event) {
    console.log(event);

    event.preventDefault()
    const target = event.target;
    let value = target.type === 'checkbox' ? target.checked : target.value;
    if(target.type !== "checkbox") {
      value = value.trim()
    }

    const name = target.name;
    this.setState({
     [name]: value
   });
   this.props.dispatch(resetAddingStock())
  }

  render() {

    let units = []
    let unitOptions = []
    if(typeof this.props.stock.stock_units !== "undefined") {
      units = this.props.stock.stock_units
      unitOptions = units.map((u, i)=>{
        return {value:u.id,label:u.compiled_unit_name}
      })
    }

    let submitButton = <input type="submit" className="btn btn-info" value="save" />
    if(this.props.stock.adding_stock) {
      submitButton = <input type="submit" className="btn btn-info" value="saving.." disabled />
    }

    let nameInputClass = "form-group"
    let nameInputError


    let submitError

    if(this.props.stock.adding_stock_error) {
      submitError = "Could not add stock item"
      console.log(this.props.stock.adding_stock_error);
      if(Array.isArray(this.props.stock.adding_stock_error.errors)) {
        this.props.stock.adding_stock_error.errors.map((item, i)=>{
          if(item.field === "name") {
              nameInputClass = "form-group has-error"
              return nameInputError = <span className="text-danger">{item.error}</span>
          }
          return null
        })
      }
    }



    let form = (<form className="form-horizontal" onSubmit={this.handleSubmit} name="createStockForm">

        <div className={nameInputClass}>
          <label className="col-sm-2">
            Name
          </label>
          <div className="col-sm-10">
              <input name="name" type="text" className="form-control input-sm" onChange={this.handleInputChange} required />
              {nameInputError}
          </div>

        </div>

        <div className="form-group">
          <label className="col-sm-2">
            Code
          </label>
          <div className="col-sm-10">
              <input name="code" type="text" className="form-control input-sm" onChange={this.handleInputChange}  />
          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-2">
            HSN Code
          </label>
          <div className="col-sm-10">
              <input name="hsn_code" type="text" className="form-control input-sm" onChange={this.handleInputChange} />
          </div>
        </div>

        <div className="form-group">

          <label className="col-sm-2">
            Quantity
          </label>
          <div className="col-sm-2">
                <input name="quantity" type="number" className="form-control input-sm" onChange={this.handleInputChange}  />
          </div>
          <label className="col-sm-1">
            Unit
          </label>
          <div className="col-sm-5">
            <Select name="unit" value={this.state.unit} onChange={this.handleUnitChange} options={unitOptions} />
          </div>
          <div className="col-sm-2">
            <AddUnitButton />
          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-2">
            Selling price
          </label>
          <div className="col-sm-10">
              <input name="selling_price" type="text" className="form-control input-sm" onChange={this.handleInputChange} />
          </div>
        </div>
        <div className="form-group">
          <label className="col-sm-2">
            Available From
          </label>
          <div className="col-sm-10">
            <DatePicker className="input-sm" dateFormat="YYYY-MM-DD" onChange={this.handleDateChange} value={this.state.available_from_date} showClearButton={false} />
          </div>
        </div>
        <div className="form-group">
          <label className="col-sm-2">
            CGST
          </label>
          <div className="col-sm-10">
              <input name="cgst_pct" type="number" className="form-control input-sm" onChange={this.handleInputChange}  />
          </div>
        </div>
        <div className="form-group">
          <label className="col-sm-2">
            SGST
          </label>
          <div className="col-sm-10">
              <input name="sgst_pct" type="number" className="form-control input-sm" onChange={this.handleInputChange}  />
          </div>
        </div>
        <div className="form-group">
          <label className="col-sm-2">
            IGST
          </label>
          <div className="col-sm-10">
              <input name="igst_pct" type="number" className="form-control input-sm" onChange={this.handleInputChange} />
          </div>
        </div>


        <div className="form-action-group text-right">
          {submitButton}
        </div>

      </form>)

    return (
      <div>
        <section className="medium">
              <h3 >Create New Stock Item</h3>
        </section>
        <div className="row">
          <div className="col-xs-12 col-md-7">
            {form}
          </div>
        </div>
        <p className="text-danger">{submitError}</p>

      </div>
      )
  }
}

const mapStateToProps = (state) => {
  return {
    stock: state.stockReducer
  }
}

export default connect(mapStateToProps)(AddStockItem)



// WEBPACK FOOTER //
// ./src/components/stockitem/addstockitem.js